import { SignIn } from "@clerk/clerk-react";

export default function SignInPage() {
  return (
    <div 
      className="min-h-screen flex items-center justify-center bg-gray-50"
      data-testid="sign-in-page"
    >
      <div className="text-center">
        <div className="mb-8">
          <img 
            src="/logo.png" 
            alt="Mind Your Waste" 
            className="h-12 mx-auto mb-4"
          />
          <h1 className="text-2xl font-bold text-gray-900 mb-2" style={{ fontFamily: 'Inter, sans-serif' }}>
            EPR/PPR Compliance Hub
          </h1>
          <p className="text-gray-500 text-sm">
            Sign in to access compliance analysis tools
          </p>
        </div>
        <SignIn 
          appearance={{
            elements: {
              rootBox: "mx-auto",
              card: "shadow-xl rounded-xl",
              formButtonPrimary: "bg-emerald-600 hover:bg-emerald-700",
              footerActionLink: "text-emerald-600 hover:text-emerald-700",
            }
          }}
          routing="path"
          path="/sign-in"
          signUpUrl="/sign-up"
        />
        <p className="mt-6 text-gray-400 text-xs">
          Powered by Mind Your Waste
        </p>
      </div>
    </div>
  );
}
